"use client";

import type { ReactNode } from "react";
import { useUserInteraction } from "@/hooks/use-user-interaction";

interface InteractionGateProps {
  children: ReactNode;
  /** Shown while waiting for scroll / pointer / keyboard interaction. */
  fallback?: ReactNode;
}

/**
 * Defers heavy / visually volatile children (ads, media) until the user
 * scrolls or otherwise interacts. Parent slots should already reserve
 * width/height so revealing the creative after interaction does not
 * contribute to CLS.
 */
export function InteractionGate({ children, fallback = null }: InteractionGateProps) {
  const interacted = useUserInteraction();
  if (!interacted) return <>{fallback}</>;
  return <>{children}</>;
}
